import { createContext } from "react";

export const FlinkContext = createContext(null);

const URL = `https://www.energymarketprice.com/flink/server/Energy/`;

export async function getData(param) {
  try {
    let result = await fetch(`${URL}${param}`);
    if (!result.ok) return alert("Something Wrong!");
    return await result.json();
  } catch (err) {
    console.log();
  }
}
